import { render } from "./introducing-zulutrade.vue?vue&type=template&id=53baa316"
import script from "./introducing-zulutrade.vue?vue&type=script&lang=js"
export * from "./introducing-zulutrade.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__